export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="bg-primary-500 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-5">
                <i className="ri-smartphone-line"></i>
                <span>移动端体验</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
                随时随地，畅享水果视频在线
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                向日葵视频完美适配手机浏览器，无需下载 App，在手机上即可访问香蕉视频、西瓜视频免费、蜜桃视频、樱花视频等所有水果视频在线平台。添加到主屏幕即可像原生应用一样使用。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 text-foreground-800 font-medium text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                  <i className="ri-android-line text-lg"></i>
                  <span>安卓浏览器访问</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/15 text-background-50 font-medium text-sm cursor-pointer hover:bg-background-50/25 transition-colors border border-background-50/30 whitespace-nowrap">
                  <i className="ri-apple-line text-lg"></i>
                  <span>iOS Safari 打开</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-8 lg:p-0">
              <div className="w-56 md:w-64 aspect-[9/16] rounded-2xl overflow-hidden bg-background-50/10 border-4 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20warm%20sunflower%20yellow%20themed%20video%20platform%20interface%20with%20fruit%20icons%20and%20video%20thumbnails%2C%20modern%20clean%20UI%20design%2C%20bright%20friendly%20colors%2C%20content%20discovery%20layout%2C%20soft%20warm%20lighting&width=360&height=640&seq=app-mockup&orientation=portrait"
                  alt="向日葵视频移动端界面预览"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.classList.add('bg-background-50/10');
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}